module.exports = __webpack_public_path__ + "img/40_38_025_390.a0a70728.jpg";